const EMPLOYER = 'employer'

export enum EmployerUsersRoutePathsEnum {
  USERS = `/${EMPLOYER}/users`,
}
